import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useProject } from "../project";
import { apiClient } from "../service/tekkr-service";

interface Input {
    taskId: string;
}

export function useDeleteProjectTaskMutation() {
    const queryClient = useQueryClient();
    const { project } = useProject();
    return useMutation({
        mutationFn: async (input: Input) => {
            const res = await apiClient.deleteProjectTask({
                params: {
                    projectId: project.id,
                    taskId: input.taskId,
                },
            });
            if (res.status !== 200) {
                throw new Error(`failed to delete project task: ${res.status}`);
            }
            await Promise.all([
                queryClient.invalidateQueries({
                    queryKey: ["project", project.id, "tasks"],
                }),
                queryClient.invalidateQueries({
                    queryKey: ["project", project.id, "progress"],
                }),
                queryClient.invalidateQueries({
                    queryKey: ["project", project.id, "next-step-suggestion"],
                }),
                queryClient.invalidateQueries({
                    queryKey: ["project-list"],
                }),
            ]);
        },
    });
}
